const BASE = process.env.REACT_APP_API_URL || "/api";

function getToken() {
  return localStorage.getItem("token");
}

async function request(method, path, body, isFormData = false) {
  const headers = {};
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;
  if (!isFormData) headers["Content-Type"] = "application/json";

  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: isFormData ? body : body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/";
    return;
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
  return data;
}

export const api = {
  // Auth
  loginEmpleado: (dni, pin) =>
    request("POST", "/auth/empleado", { dni, pin }),
  loginAdmin: (usuario, password) =>
    request("POST", "/auth/admin", { usuario, password }),

  // Empleado
  misRecibos: () => request("GET", "/recibos/mios"),
  firmarRecibo: (id) => request("POST", `/recibos/${id}/firmar`),
  pdfUrl: (id) => `${BASE}/recibos/${id}/pdf`,

  // Admin — empleados
  getEmpleados: () => request("GET", "/admin/empleados"),
  crearEmpleado: (data) => request("POST", "/admin/empleados", data),
  editarEmpleado: (id, data) => request("PUT", `/admin/empleados/${id}`, data),

  // Admin — recibos
  getRecibos: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request("GET", `/admin/recibos${qs ? "?" + qs : ""}`);
  },
  subirRecibo: (formData) => request("POST", "/admin/recibos/upload", formData, true),
  publicarRecibo: (id) => request("POST", `/admin/recibos/${id}/publicar`),
  eliminarRecibo: (id) => request("DELETE", `/admin/recibos/${id}`),

  // Admin — stats y export
  getStats: () => request("GET", "/admin/stats"),
  exportUrl: () => `${BASE}/admin/recibos/export?token=${getToken()}`,
};
